/**
 * Word-wrap a label string to at most `maxLines`, breaking on spaces.
 * The last line is ellipsized if anything is still left over.
 */
export const wrapLabelText = (
  str,
  charsPerLine = 22,
  maxLines = 2,
  spreader = "..."
) => {
  const text = String(str ?? "").trim();
  const width = Math.max(1, Number(charsPerLine) || 1);
  const linesAllowed = Math.max(1, Number(maxLines) || 1);
  if (!text) return "";

  const ellipsize = (value) => {
    if (value.length <= width) return value;
    const cut = Math.max(1, width - spreader.length);
    return `${value.slice(0, cut)}${spreader}`;
  };

  const lines = [];
  let rest = text;
  while (rest && lines.length < linesAllowed) {
    const isLast = lines.length === linesAllowed - 1;
    if (rest.length <= width) {
      lines.push(rest);
      break;
    }
    if (isLast) {
      lines.push(ellipsize(rest));
      break;
    }
    let breakAt = rest.lastIndexOf(" ", width);
    if (breakAt <= 0) breakAt = width;
    lines.push(rest.slice(0, breakAt).trimEnd());
    rest = rest.slice(breakAt).trimStart();
  }
  return lines.join("\n");
};
